import type { CSSObject } from "@emotion/serialize";

import {
  desktop,
  tablet,
  mobile,
  SpacingValues,
} from "@brexhq/shared/types/SpacingScale";

import { CSSVariableName } from "../types";

import breakpoints from "./breakpoints";

const spacing = {
  LRG: desktop,
  MED: tablet,
  SML: mobile,
  btnVerticalPadding: { large: 13, small: 9 },
  btnHorizontalPadding: { large: 30, small: 30 },
  defaultBorderRadius: 30,
  p160: 160,
  p144: 144,
  p136: 136,
  p120: 120,
  p104: 104,
  p100: 100,
  p80: 80,
  p72: 72,
  p64: 64,
  p56: 56,
  p48: 48,
  p40: 40,
  p32: 32,
  p24: 24,
  p20: 20,
  p16: 16,
  p14: 14,
  p12: 12,
  p10: 10,
  p8: 8,
  p4: 4,
  p2: 2,
  p0: 0,
  m200: 200,
  m160: 160,
  m144: 144,
  m120: 120,
  m100: 100,
  m80: 80,
  m64: 64,
  m72: 72,
  m60: 60,
  m56: 56,
  m48: 48,
  m40: 40,
  m32: 32,
  m24: 24,
  m20: 20,
  m16: 16,
  m10: 10,
  m4: 4,
  m0: 0,
};
export default spacing;

export function defineResponsiveSpacingVariable(
  variableName: CSSVariableName,
  value: SpacingValues,
): CSSObject {
  return {
    [variableName]: `${desktop[value]}px`,
    [breakpoints.MED]: { [variableName]: `${tablet[value]}px` },
    [breakpoints.SML]: { [variableName]: `${mobile[value]}px` },
  };
}

export type SpacingKeys = keyof Omit<
  typeof spacing,
  | "btnVerticalPadding"
  | "btnHorizontalPadding"
  | "defaultBorderRadius"
  | "desktop"
  | "tablet"
  | "mobile"
>;
